module.exports = __webpack_public_path__ + "img/SL-M-100-140.1571257a.svg";